"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPlacementSlipSharingDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_placement_slip_generation_entity_1 = require("./opportunity-placement-slip-generation.entity");
let OpportunityPlacementSlipSharingDetail = class OpportunityPlacementSlipSharingDetail {
};
exports.OpportunityPlacementSlipSharingDetail = OpportunityPlacementSlipSharingDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipSharingDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "placement_slip_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipSharingDetail.prototype, "placementSlipId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipSharingDetail.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "share_percentage", type: "numeric" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipSharingDetail.prototype, "sharePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "brokerage_percentage", type: "numeric" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipSharingDetail.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "brokerage_amount", type: "numeric" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipSharingDetail.prototype, "brokerageAmount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipSharingDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipSharingDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityPlacementSlipSharingDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityPlacementSlipSharingDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration, (placement) => placement.sharingDetails),
    (0, typeorm_1.JoinColumn)({ name: "placement_slip_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration !== "undefined" && opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration) === "function" ? _c : Object)
], OpportunityPlacementSlipSharingDetail.prototype, "placementSlip", void 0);
exports.OpportunityPlacementSlipSharingDetail = OpportunityPlacementSlipSharingDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_placement_slip_sharing_detail")
], OpportunityPlacementSlipSharingDetail);
